import { createFileRoute } from '@tanstack/react-router';
import { useFlagsStatus } from '@unleash/proxy-client-react';
import { useTranslation } from 'react-i18next';

import { ReportError, useQuery } from '@furality/frontend-stack';
import fox from '#/api/fox.ts';
import Booth from '@/components/_dealers/Booth';
import ExplorePage from '@/components/_explore/ExplorePage.tsx';
import { DealersLayout } from '@/components/layouts/index.tsx';
import PageLoading from '@/components/loading/PageLoading.tsx';
import PageDisabled from '@/components/PageDisabled.tsx';
import useFlag from '@/lib/hooks/useFlag.ts';
import QUERY_KEYS from '@/lib/QUERY_KEYS.ts';

const Dealer = () => {
  const { id } = Route.useParams();

  const featuresReady = useFlagsStatus().flagsReady;
  const enableDealers = useFlag('dealersDen');

  const dealers = useQuery({
    queryKey: [QUERY_KEYS.Dealer, id],
    queryFn: async () => {
      const response = await fox.value.dealerFindOne({
        params: {
          boothId: +id,
        },
      });
      switch (response.status) {
        case 200:
          return response.data;
        default:
          throw new ReportError(response);
      }
    },
    enabled: enableDealers,
  });

  useTranslation(['common', 'dealers']);

  if (!featuresReady) {
    return <PageLoading />;
  }
  if (!enableDealers) {
    return <PageDisabled absolutelyCentered />;
  }

  return (
    <>
      {dealers.isLoading && <PageLoading />}

      <ExplorePage isSubPage hideHeader title="explore:dealers">
        {dealers.isSuccess && <Booth activeBoothId={+id} />}
      </ExplorePage>
    </>
  );
};

export const Route = createFileRoute('/explore/dealer/$id')({
  component: () => (
    <DealersLayout title="explore:dealers">
      <Dealer />
    </DealersLayout>
  ),
});
